import { useQuery } from "@tanstack/react-query";
import { graphqlClient } from "@/lib/graphql";
import { graphql } from "@/__generated__";

// What a /find-a-tutor/<language> page states about its language (#1643): how many tutors a visitor
// can book and the lowest and highest lesson price among them. The server decides whether there is
// anything to state (the answer is null below three tutors), so the page copies no rule. The server
// render reads it with exactly this query (LanguagePagesController::LANGUAGE_PAGE_CLAIMS_QUERY,
// pinned by spec/requests/language_pages_claims_spec.rb) and seeds the answer under this key.
export const LANGUAGE_PAGE_CLAIMS_QUERY = graphql(`
  query LanguagePageClaims($language: String!) {
    languagePageClaims(language: $language) {
      tutorCount
      priceMinCents
      priceMaxCents
    }
  }
`);

export const languagePageClaimsKey = (code: string | undefined) => ["languagePageClaims", code] as const;

export const useLanguagePageClaims = (code: string | undefined) =>
  useQuery({
    queryKey: languagePageClaimsKey(code),
    queryFn: async () =>
      (await graphqlClient.request(LANGUAGE_PAGE_CLAIMS_QUERY, { language: code ?? "" })).languagePageClaims,
    enabled: Boolean(code),
    staleTime: 1000 * 60 * 10,
  });
